<script setup>
import StartupEditField from "@/components/startups/startupEdit/StartupEditField.vue";
import {inject, onMounted, ref} from "vue";
import locationsService from "@/services/locations.service";

const form = inject("form");

const countriesList = ref([]);
const statesList = ref([]);

onMounted(() => {
    getLocationsLists();
})

async function getLocationsLists() {
    const {data: countries} = await locationsService.getCountriesList();

    countriesList.value = countries.map(item => ({
        value: item.id,
        name: item.name
    }));

    const {data: states} = await locationsService.getStatesList();

    statesList.value = states.map(item => ({
        value: item.id,
        name: item.name
    }));
}
</script>

<template>
    <div>
        <StartupEditField
            type="select"
            field-name="countryId"
            label="Country"
            :options="countriesList"
        />

        <StartupEditField
            v-if="form.countryId === 1"
            type="select"
            field-name="stateId"
            label="State"
            :options="statesList"
        />

        <StartupEditField
            field-name="regionName"
            label="Region Name"
        />

        <StartupEditField
            field-name="city"
            label="City"
        />

        <StartupEditField
            field-name="address1"
            label="Address 1"
        />

        <StartupEditField
            field-name="address2"
            label="Address 2"
        />

        <StartupEditField
            field-name="zip"
            label="Zip"
        />
    </div>
</template>

<style scoped>

</style>
